export const ROUTES = {
  LOGIN: '/login',
  RECOVERY: '/recovery',
  HOME: '/',
  AGENCY_MANAGEMENT: {
    INDEX: '/agency-management',
    PAYMENT_INFORMATION: '/agency-management/payment/information',
    GUIDELINES: '/agency-management/guidelines',
    PAYPAL_COMMISSION: '/agency-management/paypal-commission',
  },
  BOOKING_MANAGEMENT: {
    INDEX: '/bookings',
    NEW: '/bookings/new',
    PAY: '/bookings/pay/:id',
    RETAILER_CANCELLATIONS: '/bookings/retailer-cancellations',
    HELD_BOOKINGS: '/bookings/held',
    BOOKING_DETAIL: '/bookings/:id',
    HELD_BOOKING_DETAIL: '/bookings/held/:id',
    AGENT_DETAIL: '/admin/users/:id',
    AMEND: '/bookings/amend/:id',
    TICKET_VALIDATOR: '/bookings/ticket-validator',
    CANCELLATIONS: '/bookings/cancellations',
    SUBSCRIPTIONS: '/bookings/subscriptions',
    SUBSCRIPTION_DETAIL: '/bookings/subscriptions/:id',
    CUSTOMERS: '/bookings/customers',
  },
  DASHBOARDS: {
    INDEX: '/dashboards',
    WELCOME: '/dashboards/welcome',
    PARTNER: '/dashboards/partner',
    GLOBAL_INVENTORY: '/dashboards/global-inventory',
    PASSENGER_MANIFEST: '/dashboards/passenger-manifest',
    SLA: '/dashboards/sla',
  },
  FINANCES: {
    INDEX: '/finances',
    FINANCIAL_DOCUMENTS: '/finances/financial-documents',
  },
  TRADING_DESK: {
    INDEX: '/trading-desk',
    CARRIER_PROFILE: '/trading-desk/:rpn/carrier/:id',
    RETAILERS: '/trading-desk/retailers',
    RETAILER_PROFILE: '/trading-desk/retailers/:id',
  },
  PRICING: {
    INDEX: '/pricing',
  },
  CONFIGURATION: {
    INDEX: '/configuration',
    WEBSITE_CONFIGURATION: '/configuration/website-configuration',
    SEARCH_PAGE_EDITOR: '/configuration/website-configuration/search/:rpn',
    LANDING_PAGE_EDITOR: '/configuration/website-configuration/landing/:rpn',
    SETTINGS: '/configuration/settings',
    UPCOMING_FEATURES_EDITOR: '/configuration/upcoming-features/edit-features',
    UPCOMING_FEATURES_PREVIEW: '/configuration/upcoming-features/preview',
  },
  USERS: {
    INDEX: '/admin/users',
    CREATE: '/admin/users/create',
    CREATE_OLD: '/admin/users/old/create',
    DETAIL: '/admin/users/:id',
    EDIT: '/admin/users/:id/edit',
    AGENCY: '/admin/users/agency/:type/:id',
  },
  API_DOCS: 'https://docs.distribusion.com',
  SERVICE_DESK: 'https://distribusion.atlassian.net/servicedesk/customer/portals',
};

export enum PagesEnum {
  Settings = 'settings',
  Users = 'users',
  User = 'user',
  EditUser = 'edit-user',
}

// TODO: move to assets folder and replace with imports
// Paths to files in /public folder
export const DISTRIBUSION_DEFAULT_LOGO = '/distribusion-logo.png';
export const DISTRIBUSION_SMALL_LOGO = '/distribusion-logo-small.png';
export const DISTRIBUSION_PRIMARY_LOGO = '/distribusion-logo-primary.png';
export const RAILAGENT_LOGO = '/railagent-logo.png';

export const DISTRIBUSION_TITLE = 'Distribusion';

export const USER_MANAGEMENT_BASE_API_PATH = '/portal/user-management';
